<template>
  <Carousel 
    v-model="carouselIndex" 
    :loop="loop" 
    :dots="dots" 
    :arrow="arrow"
  >
  
    <CarouselItem 
      v-for="(item,index) in carouselItems"
      :key="`carousel-${index}`"
    >
    <a :href="`${item.url}`">
      <div 
        class="carousel-item"
        :style="{ backgroundImage: `url(${item.img})`,backgroundSize: `cover` }"
      > 
        <!-- <h1 
          class="carousel-item-title"
          v-text="item.title"
        /> 
         <h3 
          class="carousel-item-subtitle"
          v-text="item.subTitle"
        />     -->
        
        </div>
    </a>
    </CarouselItem>
  </Carousel>
</template>

<script>
  import { Carousel, CarouselItem } from 'iview';

  export default {
    components: {
      Carousel,
      CarouselItem
    },
    props: {
      dots: {
        type: String,
        default: 'none'
      },
      loop: {
        type: Boolean,
        default: false
      },
      arrow: {
        type: String,
        default: 'always'
      },
      carouselItems: {
        type: Array,
        default: () => {}
      }
    },
    data() {
      return {
        carouselIndex: 0,
      };
    }
  };
</script>
